// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/images.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.assets.v1.SrcSet
 */
export interface SrcSet {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.Candidate candidates = 1
     */
    candidates: Candidate[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.Candidate
 */
export interface Candidate {
    /**
     * @generated from protobuf field: string src = 1
     */
    src: string;
    /**
     * @generated from protobuf field: uint32 width = 2
     */
    width: number;
    /**
     * @generated from protobuf field: c1.api.assets.v1.ImageMimeType mime_type = 3
     */
    mimeType: ImageMimeType;
}
/**
 * @generated from protobuf enum c1.api.assets.v1.ImageMimeType
 */
export enum ImageMimeType {
    /**
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * image/png
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_PNG = 1;
     */
    PNG = 1,
    /**
     * image/webp
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_WEBP = 2;
     */
    WEBP = 2,
    /**
     * image/jpeg
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_JPEG = 3;
     */
    JPEG = 3,
    /**
     * image/svg+xml
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_SVG = 4;
     */
    SVG = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class SrcSet$Type extends MessageType<SrcSet> {
    constructor() {
        super("c1.api.assets.v1.SrcSet", [
            { no: 1, name: "candidates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Candidate }
        ]);
    }
    create(value?: PartialMessage<SrcSet>): SrcSet {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.candidates = [];
        if (value !== undefined)
            reflectionMergePartial<SrcSet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SrcSet): SrcSet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.Candidate candidates */ 1:
                    message.candidates.push(Candidate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SrcSet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.Candidate candidates = 1; */
        for (let i = 0; i < message.candidates.length; i++)
            Candidate.internalBinaryWrite(message.candidates[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.SrcSet
 */
export const SrcSet = new SrcSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Candidate$Type extends MessageType<Candidate> {
    constructor() {
        super("c1.api.assets.v1.Candidate", [
            { no: 1, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "mime_type", kind: "enum", T: () => ["c1.api.assets.v1.ImageMimeType", ImageMimeType, "IMAGE_MIME_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<Candidate>): Candidate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.src = "";
        message.width = 0;
        message.mimeType = 0;
        if (value !== undefined)
            reflectionMergePartial<Candidate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Candidate): Candidate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src */ 1:
                    message.src = reader.string();
                    break;
                case /* uint32 width */ 2:
                    message.width = reader.uint32();
                    break;
                case /* c1.api.assets.v1.ImageMimeType mime_type */ 3:
                    message.mimeType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Candidate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src = 1; */
        if (message.src !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.src);
        /* uint32 width = 2; */
        if (message.width !== 0)
            writer.tag(2, WireType.Varint).uint32(message.width);
        /* c1.api.assets.v1.ImageMimeType mime_type = 3; */
        if (message.mimeType !== 0)
            writer.tag(3, WireType.Varint).int32(message.mimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.Candidate
 */
export const Candidate = new Candidate$Type();
